export default Object.freeze({
    TYPE: {
        CONSULTATION: 0,
        RETURN: 1,
        EMERGENCY: 2,
        HOSPITALIZATION: 3
    },
    STATUS: {
        IN_PROGRESS: 0,
        FINISHED: 1
    },
    getTypeLabel(type, getLabel) {
        const map = {
            0: getLabel('ENCOUNTER'),
            1: getLabel('RETURN'),
            2: getLabel('EMERGENCY'),
            3: getLabel('HOSPITALIZATION')
        };
        return map[type] || getLabel('ENCOUNTER');
    },
    getStatusLabel(status, getLabel) {
        return status === 1 ? getLabel('FINISHED') : getLabel('DRAFT');
    },
    getTypeList(getLabel) {
        return [
            { value: 0, text: getLabel('ENCOUNTER') },
            { value: 1, text: getLabel('RETURN') },
            { value: 2, text: getLabel('EMERGENCY') },
            { value: 3, text: getLabel('HOSPITALIZATION') }
        ];
    }
});
